import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import vuetify from './plugins/vuetify'
import './registerServiceWorker'

import _ from 'lodash'
Object.defineProperty(Vue.prototype, '$_', { value: _ })

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  created() {
    const userString = localStorage.getItem('user') // grab user data from local storage
    if (userString) {
      // check to see if there is indeed a user
      const userData = JSON.parse(userString) // parse user data into JSON
      this.$store.commit('SET_USER_DATA', userData) // restore user data with Vuex
      this.$store.commit(
        'SET_ACCESS_TOKEN',
        localStorage.getItem('accesstoken')
      )
      this.$store.commit(
        'SET_REFRESH_TOKEN',
        localStorage.getItem('refreshtoken')
      )
      console.log('getting user info from local storage:', userData)
    }
    const gotoURL = localStorage.getItem('goto_url')

    if (gotoURL) {
      console.log('GOTOURL in Local store:', gotoURL)
      this.$store.commit('SET_GOTO_URL', gotoURL)
    }

    const articlesListOptions = localStorage.getItem('articlesListOptions')
    if (articlesListOptions) {
      console.log(
        'articlesListOptions in Local store:',
        JSON.parse(articlesListOptions)
      )
      this.$store.commit(
        'SET_ARTICLES_LIST_OPTIONS',
        JSON.parse(articlesListOptions)
      )
    }

    this.$store.dispatch('fetchVersion')
  },
  render: h => h(App)
}).$mount('#app')
